import { render, staticRenderFns } from "./UsuarioFormArquivo.vue?vue&type=template&id=efe10c1e"
import script from "./UsuarioFormArquivo.vue?vue&type=script&lang=js"
export * from "./UsuarioFormArquivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports